export const PAGES = {
  INTRO: "intro",
  SELECT: "select",
  GAME: "game",
  END: "end",
};

// src/data/constants.js

export const initialState = {
  tech: 50, industry: 50, stability: 50, self: 50,
  publicOpinion: 50, // 🌟 新增：隐藏的舆论指数（50为中立，0被网暴，100成意见领袖）
  round: 1, tags: [], model: "",
  money: 12000,
  gameMonths: 0,
  san: 85,
  playedEvents: [],
  // 🌟 新增：NPC 好感度（0-100，50为中立）
  rels: {
    boss: 50,   // 老板：决定你是否会被开除，是否能拿到资源
    team: 50,   // 团队：决定系统出Bug的频率，以及关键时刻是否有人顶罪
    family: 50  // 家人：San 值的最后避风港，决定了你的精神防线
  },
  // 🌟 新增：股票市场大盘与玩家持仓
  stocks: {
    cyber: { name: "赛博科技", price: 100, history: [100] },
    waibao: { name: "老王外包", price: 50, history: [50] },
    doge: { name: "狗币(DOGE)", price: 10, history: [10] }
  },
  portfolio: {
    cyber: 0,
    waibao: 0,
    doge: 0
  },
  historyLog: [],

};

export const modelEffects = {
  gpt: { tech: 10, industry: -15 },
  safe: { stability: 15 },
  open: { industry: 15, tech: -5 },
  capital: { tech: 15, stability: -15 },
};

export const clamp = (v) => Math.max(0, Math.min(100, v));